module.exports = __webpack_public_path__ + "img/cover25.016cf386.png";